const success = {
    saved: 'Saved successfully',
    uploaded: 'Uploaded successfully',
    deleted: 'Deleted successfully',
    updated: 'Updated successfully',
    shared: 'Shared successfully',
  };

export default success;
